import { Spinner as ChakraSpinner } from "@chakra-ui/react"

interface SpinnerProps extends React.ComponentProps<typeof ChakraSpinner> {
  size?: "xs" | "sm" | "md" | "lg" | "xl"
  colorPalette?: "gray" | "red" | "orange" | "yellow" | "green" | "teal" | "blue" | "cyan" | "purple" | "pink"
}

export const Spinner = ({ ...props }: SpinnerProps) => {
  return <ChakraSpinner {...props} />
}
